"use strict";

require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pipe = exports.isObject = exports.isNumber = exports.isFunction = exports.isArray = exports.handleArrayToObject = exports.composes = exports.compose = void 0;
var isType = function isType(type) {
  return function (data) {
    return Object.prototype.toString.call(data) === "[object ".concat(type, "]");
  };
};
var isObject = isType('Object');
exports.isObject = isObject;
var isArray = isType('Array');
exports.isArray = isArray;
var isFunction = isType('Function');
exports.isFunction = isFunction;
var isNumber = isType('Number');
exports.isNumber = isNumber;
var handleArrayToObject = function handleArrayToObject(data) {
  return data.reduce(function (prev, curr) {
    Object.keys(curr).forEach(function (x) {
      return prev[x] = curr[x];
    });
    return prev;
  }, {});
};
exports.handleArrayToObject = handleArrayToObject;
var compose = function compose() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  if (fns.length === 0) {
    return function (arg) {
      return arg;
    };
  }
  if (fns.length === 1) {
    return fns[0];
  }
  return fns.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
};
exports.compose = compose;
var composes = function composes() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }
  return function (x) {
    return fns.reduceRight(function (arg, fn) {
      return fn(arg);
    }, x);
  };
};
exports.composes = composes;
var pipe = function pipe() {
  for (var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    fns[_key3] = arguments[_key3];
  }
  return function (x) {
    return fns.reduce(function (arg, fn) {
      return fn(arg);
    }, x);
  };
};
exports.pipe = pipe;